import styled from 'styled-components';

export const Container = styled.div`
  .font-color-title {
    color: #354153;
  }
`;
